import { useState } from "react";
import { Link } from "react-router-dom";
import { api, extractApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(""); setMsg("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (e2) {
      setErr(extractApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-8">
      <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="forgot-form">
        <Link to="/login" className="label-mono mb-2 block hover:text-volt">← BACK TO LOGIN</Link>
        <h1 className="font-display text-4xl font-black mb-2">RESET PASSWORD</h1>
        <p className="text-muted-foreground mb-8">Enter your email — we'll send a reset link.</p>
        <label className="label-mono block mb-2">Email</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} required type="email"
               className="w-full bg-secondary border border-border px-4 py-3 mb-6 focus:outline-none focus:border-volt"
               data-testid="forgot-email-input" />
        {msg && <div className="border border-volt text-volt px-4 py-2 mb-4 text-sm" data-testid="forgot-success">{msg}</div>}
        {err && <div className="border border-destructive text-destructive px-4 py-2 mb-4 text-sm" data-testid="forgot-error">{err}</div>}
        <button disabled={busy} className="w-full bg-volt text-black py-4 font-display uppercase tracking-widest font-bold hover:bg-white disabled:opacity-50" data-testid="forgot-submit-btn">
          {busy ? "Sending..." : "Send Reset Link"}
        </button>
      </form>
    </div>
  );
}
